import React from "react";
import { Link } from "react-router-dom";
import Button from "./Button";
import CustomInput from "./CustomInput";
import PickInput from "./PickInput";
import { useRef } from "react";
import { GooglePersonalizedLoginButton } from "react-google-identity-gsi";

const LoginForm = () => {
  const googleLogin = useRef(null);
  const handleCallbackResponse = (response) => {
    console.log(response);
  };
  const CLIENT_ID =
    "226390969933-1fhk9p3l2m33seldtls5f2hgk9bo6btn.apps.googleusercontent.com";
  const buttonCustomization = {
    locale: "en",
    text: "continue_with",
    size: "large",
    width: window.innerWidth > 500 ? "400" : "250",
  };

  return (
    <div className="">
      <div className="pb-5" id="google-login" ref={googleLogin}>
        <GooglePersonalizedLoginButton
          clientId={CLIENT_ID}
          buttonCustomization={buttonCustomization}
          onUserAuthenticationSucceeded={handleCallbackResponse}
        />
      </div>
      <form action="">
        <div className="pb-5 last:pb-0">
          <CustomInput
            label="Email Address"
            name={"email"}
            type="email"
            placeholder="Enter your email"
          />
        </div>
        <div className="pb-5 last:pb-0">
          <CustomInput
            label="Password"
            name={"password"}
            type="password"
            placeholder="Enter your password"
          />
        </div>
        <div className="pb-5 last:pb-0 flex text-sm text-[#9e9e9e]">
          <PickInput id={"remember"} name="remember">
            Remember me
          </PickInput>
        </div>
        <div>
          <Button width={"w-full"}>Login</Button>
        </div>
        <div className="have-no-account pt-5 text-sm text-[#8b8b8b] flex justify-center">
          <p>
            <span>Don't have an account </span>
            <span className="text-[#e66553]">Sign Up</span>
          </p>
        </div>

        <div className="forget-password text-base text-[#e66553] flex justify-center pt-5">
          <Link to="/reset-password/email-confirmation">Forget Password</Link>
        </div>
      </form>
    </div>
  );
};

export default LoginForm;
